export default __webpack_public_path__ + "static/media/Heartland-Paver-Sand-Stone-Mocha.c5b8c6c5.jpg";